import {
  DictionaryField,
  DictionaryFieldFromApi,
  FieldId,
} from '../../gk-dynamic-list/services/dictionary/dictionary.model';
import {
  CommunityGusDictionaryRequestBody,
  CommunityGusField,
} from '../community-gus-dictionary/community-gus-dictionary.model';

export class PlaceGusDictionaryRequestBody extends CommunityGusDictionaryRequestBody {
  constructor(
    public GminaId: string | number,
    public RodzajGminaId: string | number,
    public override WojewId: string | number,
    public override PowiatId: string | number,
  ) {
    super(WojewId, PowiatId);
  }

  static fromCommunityGus(
    data: CommunityGusField,
  ): PlaceGusDictionaryRequestBody {
    return new this(data.id, data.typeId, data.voivodeshipId, data.districtId);
  }

  override getCacheKey(): string {
    return `${this.WojewId}-${this.PowiatId}-${this.GminaId}-${this.RodzajGminaId}`;
  }
}

export class PlaceGusFieldFromApi extends DictionaryFieldFromApi {
  constructor(
    public NazwaDisplay: string,
    public override Id: FieldId,
    public override Nazwa: string,
  ) {
    super(Id, Nazwa);
  }
}

export class PlaceGusField extends DictionaryField {
  constructor(
    public override id: FieldId,
    public override name: string,
    public displayName: string,
  ) {
    super(id, name);
  }

  static override fromApiToApp(
    fieldFromApi: PlaceGusFieldFromApi,
  ): PlaceGusField {
    return new this(
      fieldFromApi.Id,
      fieldFromApi.Nazwa,
      fieldFromApi.NazwaDisplay,
    );
  }
}
